import React, { ReactNode, useMemo } from 'react';
import { Permission, PERMISSIONS } from 'services/StaffUtils';
import Info from '../info';
import './style.scss';
import { useAppSelector } from 'careand-redux/store';

export const ALLOW_ALL: Permission[] = [
  PERMISSIONS.super_admin,
  PERMISSIONS.shift_manager,
  PERMISSIONS.statistics,
];

function DashboardBox({
  className,
  title,
  titleExtras,
  info,
  children,
  allow,
  hidden,
}: {
  className?: string;
  title?: ReactNode;
  info?: ReactNode;
  titleExtras?: ReactNode;
  children: ReactNode;
  allow: Permission | Permission[];
  /** Hide regardless of permissions — for tiles whose underlying feature the
   * tenant doesn't run (e.g. rostering without continuity of care). */
  hidden?: boolean;
}) {
  const permissions = useAppSelector((state) => state.authentication.permissions);

  const hasPermission = useMemo(() => {
    if (typeof allow === 'string') {
      return permissions.includes(allow);
    }

    if (!allow || allow.length === 0) {
      throw 'AccessControl component expects an allowList but no values were provided (access was denied by default)';
    }
    for (let required of allow) {
      if (permissions.includes(required)) {
        return true;
      }
    }
    return false;
  }, [permissions, allow]);

  if (hidden) return null;

  return hasPermission ? (
    <div className={`dashboard-box ${className}`}>
      {title && (
        <span className="dashboard-section-title">
          {title}
          <Info tooltip={info} />
          {titleExtras}
        </span>
      )}
      {children}
    </div>
  ) : null;
}

export default DashboardBox;
